// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"8fbb4fbd","84":"d0c2862b","231":"a85afa99","513":"3d85fa8d","547":"87f645ed","707":"7ccd1b51","781":"f16066c3"}[chunkId] + ".chunk.js";
};